import React from 'react';
import { slugify } from '../components/slugify';
import Helmet from 'react-helmet'
import 'mapbox-gl/dist/mapbox-gl.css';
import { Textfit } from 'react-textfit';
import Img from "gatsby-image";
import Link from "gatsby-link";
import Particles from 'react-particles-js';
import Slider from "react-slick";
import MediaQuery from 'react-responsive';
import IndexMap from '../components/index-map';
import KontaktMap from '../components/kontakt-map';




const HomePage = ({ data }) => (

  <div>
    <Helmet
      bodyAttributes={{
        class: 'home'
      }}
    />
    {/* <!-- 1st row --> */}
    <div className="row">
      <div className="col-xs-12 col-md-5 col-lg-6 welcomeImg r1t1">
        <Link to={`/buero/`}>
          <Img
            sizes={data.boleymeier.sizes}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              height: "auto",
              width: "100%"
            }}
          />
        </Link>
      </div>
      <div className="col-xs-12 col-md-7 col-lg-6 r1t2">


        <div className="col-xs-12 col-md-12 r1t3 not-xs">
          <Particles params={{

            "particles": {
              "number": {
                "value": 5,
                "density": {
                  "enable": true,
                  "value_area": 100
                }
              },
              "color": {
                "value": "#ffffff"
              },
              "shape": {
                "type": "circle",
                "stroke": {
                  "width": 0,
                  "color": "#000000"
                },
                "polygon": {
                  "nb_sides": 4
                },
                "image": {
                  "src": "img/github.svg",
                  "width": 100,
                  "height": 100
                }
              },
              "opacity": {
                "value": 0.4249029187022423,
                "random": false,
                "anim": {
                  "enable": false,
                  "speed": 1,
                  "opacity_min": 0.1,
                  "sync": false
                }
              },
              "size": {
                "value": 3,
                "random": true,
                "anim": {
                  "enable": true,
                  "speed": 12.18119527978683,
                  "size_min": 0.1,
                  "sync": false
                }
              },
              "line_linked": {
                "enable": true,
                "distance": 160.34072403858198,
                "color": "#ffffff",
                "opacity": 0.6549938347718866,
                "width": 1
              },
              "move": {
                "enable": true,
                "speed": 1.60340724038582,
                "direction": "right",
                "random": false,
                "straight": false,
                "out_mode": "out",
                "bounce": false,
                "attract": {
                  "enable": false,
                  "rotateX": 1122.385068270074,
                  "rotateY": 1200
                }
              }
            },
            "interactivity": {
              "detect_on": "canvas",
              "events": {
                "onhover": {
                  "enable": false,
                  "mode": "grab"
                },
                "onclick": {
                  "enable": false,
                  "mode": "push"
                },
                "resize": true
              },
              "modes": {
                "grab": {
                  "distance": 400,
                  "line_linked": {
                    "opacity": 1
                  }
                },
                "bubble": {
                  "distance": 400,
                  "size": 40,
                  "duration": 2,
                  "opacity": 8,
                  "speed": 3
                },
                "repulse": {
                  "distance": 200,
                  "duration": 0.4
                },
                "push": {
                  "particles_nb": 4
                },
                "remove": {
                  "particles_nb": 2
                }
              }
            },
            "retina_detect": true
          }
          }
          />
        </div>


        <div className="col-xs-12 col-md-12 job-container">
          <small>Zur Verst&auml;rkung unseres Teams suchen wir eine/n</small>

          <Slider>
            {data.allStrapiStellenangebote.edges.map((jobs) => {

              const isPublic = (jobs.node.Public == true);
              let sliderDiv;

              if (isPublic) {

                sliderDiv = (

                  <div key={'k' + jobs.node.id}>
                    <Link key={"l" + jobs.node.id} to={`/karriere/${slugify(jobs.node.Title)}-${slugify(jobs.node.Job_Location)}`}>
                      <div key={'j' + jobs.node.id} className="jobHead">
                        <h2 key={"t" + jobs.node.id}>{jobs.node.Title}</h2>
                      </div>
                    </Link>
                  </div>
                )
                return (
                  sliderDiv
                )
              }

            })
            }
          </Slider>

        </div>
      </div>
    </div>

    {/* <!-- 2nd row --> */}
    <div className="row lastRow" style={{ overflow: 'hidden' }}>

      {/* <div className="col-xs-12 col-md-5" style={{ padding: '0', height: '30vh' }}> */}
      <div className="col-xs-12 col-md-5 lastRow">

        <div className="col-xs-12 r2t1">
          <Textfit mode="multi"
            min={11}
            max={16}>
            Unsere Leistungen umfassen die ganze Bandbreite der geotechnischen Beratung und Planung. Wir unterstützen Sie – von der Beratung über die Planung und Prüfung bis zur Bauüberwachung. Wenn Sie mit uns zusammenarbeiten, dürfen Sie breites Fachwissen, höchste Sorgfalt und ein wertschätzendes Miteinander erwarten.
            </ Textfit>
        </div>


        <div className="col-xs-12" id="MyMapContainer">

          <MediaQuery query="(max-width: 1000px)">
            <KontaktMap />
          </MediaQuery>

          <MediaQuery query="(min-width: 1001px)">
            <IndexMap />
          </MediaQuery>

        </div>

      </div>


      <div className="col-xs-12 col-md-3 r2t2">
        <Slider>

          <div key={data.allStrapiArbeitsgebiete.edges[0].node.id}>
            <Link
              className="col-xs-12"
              to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[0].node.Title)}`}
            >
              <div className="row">
                <div className="row-image" style={{
                  background: 'url(' + data.tunnelbau.edges[0].node.publicURL + ')',
                  backgroundSize: 'cover',
                  backgroundPositionX: '80%'
                }}
                >
                  <div className="row">

                    <div className="col-xs-8">
                      <span className="indicator">
                        <div className="row">
                          <div className="col-xs-12 title-section">
                            <div>
                              {data.allStrapiArbeitsgebiete.edges[0].node.Title}
                            </div>
                          </div>

                          <div className="col-xs-12 ag-section">
                            Leistungen & Arbeitsgebiete
                            </div>
                        </div>
                      </span>
                    </div>
                    <div className="col-xs-4">
                    </div>
                  </div>

                </div>
              </div>
            </Link>
          </div>


          <div key={data.allStrapiArbeitsgebiete.edges[5].node.id}>
            <Link
              className="col-xs-12"
              to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[5].node.Title)}`}
            >
              <div className="row">
                <div className="row-image" style={{
                  background: 'url(' + data.energie.edges[0].node.publicURL + ')',
                  backgroundSize: 'cover',
                  backgroundPositionX: '80%'
                }}
                >
                  <div className="row">

                    <div className="col-xs-8">
                      <span className="indicator">
                        <div className="row">
                          <div className="col-xs-12 title-section">
                            {data.allStrapiArbeitsgebiete.edges[5].node.Title}
                          </div>

                          <div className="col-xs-12 ag-section">
                            Leistungen & Arbeitsgebiete
                            </div>
                        </div>
                      </span>
                    </div>
                    <div className="col-xs-4">
                    </div>
                  </div>

                </div>
              </div>
            </Link>
          </div>



          <div key={data.allStrapiArbeitsgebiete.edges[6].node.id}>
            <Link
              className="col-xs-12"
              to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[6].node.Title)}`}
            >
              <div className="row">
                <div className="row-image" style={{
                  background: 'url(' + data.verkehr.edges[0].node.publicURL + ')',
                  backgroundSize: 'cover',
                  backgroundPositionX: '70%'
                }}
                >
                  <div className="row">

                    <div className="col-xs-8">
                      <span className="indicator">
                        <div className="row">
                          <div className="col-xs-12 title-section">
                            {data.allStrapiArbeitsgebiete.edges[6].node.Title}
                          </div>

                          <div className="col-xs-12 ag-section">
                            Leistungen & Arbeitsgebiete
                            </div>
                        </div>
                      </span>
                    </div>
                    <div className="col-xs-4">
                    </div>
                  </div>

                </div>
              </div>
            </Link>
          </div>




          <div key={data.allStrapiArbeitsgebiete.edges[2].node.id}>
            <Link
              className="col-xs-12"
              to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[2].node.Title)}`}
            >
              <div className="row">
                <div className="row-image" style={{
                  background: 'url(' + data.kampfmittel.edges[0].node.publicURL + ')',
                  backgroundSize: 'cover',
                  backgroundPositionX: '33%'
                }}
                >
                  <div className="row">

                    <div className="col-xs-8">
                      <span className="indicator">
                        <div className="row">
                          <div className="col-xs-12 title-section">
                            {data.allStrapiArbeitsgebiete.edges[2].node.Title}
                          </div>

                          <div className="col-xs-12 ag-section">
                            Leistungen & Arbeitsgebiete
                            </div>
                        </div>
                      </span>
                    </div>
                    <div className="col-xs-4">
                    </div>
                  </div>

                </div>
              </div>
            </Link>
          </div>


          <div key={data.allStrapiArbeitsgebiete.edges[0].node.id}>
            <Link
              className="col-xs-12"
              to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[1].node.Title)}`}
            >
              <div className="row">
                <div className="row-image" style={{
                  background: 'url(' + data.schulung.edges[0].node.publicURL + ')',
                  backgroundSize: 'cover',
                  backgroundPositionX: '33%'
                }}
                >
                  <div className="row">

                    <div className="col-xs-8">
                      <span className="indicator">
                        <div className="row">
                          <div className="col-xs-12 title-section">
                            {data.allStrapiArbeitsgebiete.edges[1].node.Title}
                          </div>

                          <div className="col-xs-12 ag-section">
                            Leistungen & Arbeitsgebiete
                            </div>
                        </div>
                      </span>
                    </div>
                    <div className="col-xs-4">
                    </div>
                  </div>

                </div>
              </div>
            </Link>
          </div>

          <div key={data.allStrapiArbeitsgebiete.edges[3].node.id}>
            <Link
              className="col-xs-12"
              to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[3].node.Title)}`}
            >
              <div className="row">
                <div className="row-image" style={{
                  background: 'url(' + data.geotechnik.edges[0].node.publicURL + ')',
                  backgroundSize: 'cover',
                  backgroundPositionX: '33%',
                  backgroundPositionY: 'bottom'
                }}
                >
                  <div className="row">

                    <div className="col-xs-8">
                      <span className="indicator">
                        <div className="row">
                          <div className="col-xs-12 title-section">
                            {data.allStrapiArbeitsgebiete.edges[3].node.Title}
                          </div>
                          <div className="col-xs-12 ag-section">
                            Leistungen & Arbeitsgebiete
                            </div>
                        </div>
                      </span>
                    </div>
                    <div className="col-xs-4">
                    </div>
                  </div>

                </div>
              </div>
            </Link>
          </div>

          <div key={data.allStrapiArbeitsgebiete.edges[4].node.id}>
            <Link
              className="col-xs-12"
              to={`/leistungen-arbeitsgebiete/${slugify(data.allStrapiArbeitsgebiete.edges[4].node.Title)}`}
            >
              <div className="row">
                <div className="row-image" style={{
                  background: 'url(' + data.wasserbau.edges[0].node.publicURL + ')',
                  backgroundSize: 'cover',
                  backgroundPositionX: '33%'
                }}
                >
                  <div className="row">

                    <div className="col-xs-8">
                      <span className="indicator">
                        <div className="row">
                          <div className="col-xs-12 title-section">
                            {data.allStrapiArbeitsgebiete.edges[4].node.Title}
                          </div>
                          <div className="col-xs-12 ag-section">
                            Leistungen & Arbeitsgebiete
                            </div>
                        </div>

                      </span>
                    </div>
                    <div className="col-xs-4">
                    </div>
                  </div>

                </div>
              </div>
            </Link>
          </div>

        </Slider>


      </div>
      <div className="col-xs-12 col-md-4 r2t3">
        <span className="indicator">
          Projekte
          </span>
        <Link to={`/projekte/`}>
          <Img
            sizes={data.tasse.sizes}
            style={{
              position: "relative",
              left: 0,
              top: 0,
              width: "100%",
              height: "100%"
            }}
          />
        </Link>
      </div>


    </div>
  </div>

)



export default HomePage

export const pageQuery = graphql`  
  query IndexQuery {
   boleymeier: imageSharp(id: {regex:"/alle_1600/"}){
    sizes(maxWidth: 1600){
      ...GatsbyImageSharpSizes
    }
  },
   tasse: imageSharp(id: {regex:"/bg_tasse@2x/"}){
    sizes(maxWidth: 800){
      ...GatsbyImageSharpSizes
    }
  },
     tunnelbau: allFile(filter: {id: { regex:"/img_tunnelbau@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
     energie: allFile(filter: {id: { regex:"/img_energie/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      geotechnik: allFile(filter: {id: { regex:"/img_geotechnik@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      kampfmittel: allFile(filter: {id: { regex:"/img_kampfmittel@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      schulung: allFile(filter: {id: { regex:"/img_schulung@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      verkehr: allFile(filter: {id: { regex:"/img_verkehr@2x/"} }){
        edges{
            node{
                publicURL
            }
        }
    },
      wasserbau: allFile(filter: {id: { regex:"/img_wasserbau/"} }){
        edges{
            node{
                publicURL
            }
        }
      },
    allStrapiArbeitsgebiete {
      edges {
        node {
            id
            Title
            Arbeitsgebiet_Detail_Text
            Arbeitsgebiet_Detail_List
            Arbeitsgebiete_Image{
                    childImageSharp{
                    sizes {
                    base64
                    tracedSVG
                    aspectRatio
                    src
                    srcSet
                    srcWebp
                    srcSetWebp
                    sizes
                    originalImg
                    originalName
                    }
                }
            }
        }
      }
    },
      allStrapiStellenangebote(sort: { fields: [updatedAt], order: DESC }) {
      edges {
          node {
            Title
            Job_Location
            id
            updatedAt
            Public
          }
      }
    },
      strapiMetadata{
        SiteTitle
        Keywords
        placeholder_img{
          childImageSharp{
            sizes{
              src
            }
          }
        }
      }
  }
`




// WEBPACK FOOTER //
// ./src/pages/index.js